import React from 'react';
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs';

import CheckLine from "./CheckLine";
import {assetsBaseUrl} from "../../../services/calculationsApi";
import {FormattedMessage} from "react-intl";

function StepSidebar({toggleSidebar, sidebarType, intl}) {

    return (
        <div className="ct-step__sidebar">
            <div className="ct-step__sidebar-close">
                <img src={`${assetsBaseUrl}/assets/svg/close.svg`} alt="" onClick={toggleSidebar}/>
            </div>

            <div className="ct-step__sidebar-content">

                <div className="ct-step__sidebar-title">
                    {(sidebarType === 'mortgage-info') ? intl.formatMessage({ id: 'stepSidebar.mortgageInfo.title' , defaultMessage: 'Hypotheekvormen'})
                    : intl.formatMessage({ id: 'stepSidebar.period.title' , defaultMessage: 'Rentevaste periode'})}
                </div>

                {(sidebarType === 'mortgage-info') ? (
                    <Tabs>
                        <TabList>
                            <Tab>
                              <FormattedMessage id={'stepSidebar.mortgageInfo.annuity.title'} defaultMessage={'Annuïteiten'} />
                            </Tab>

                            <Tab>
                              <FormattedMessage id={'stepSidebar.mortgageInfo.linear.title'} defaultMessage={'Lineair'} />
                            </Tab>
                        </TabList>

                        <TabPanel>
                            <div className="ct-tab__title">
                              <FormattedMessage id={'stepSidebar.mortgageInfo.annuity.payoff'} defaultMessage={'In het begin meer rente, tegen het einde meer aflossing'} />
                            </div>

                            <div className="ct-tab__text">
                              <FormattedMessage id={'stepSidebar.mortgageInfo.annuity.text'} defaultMessage={'Met een annuïteitenhypotheek blijft het totaal van de bruto rente en de aflossing gedurende de looptijd gelijk. De verhouding tussen de aflossing en het rentebedrag verandert iedere maand. In het begin betaal je het grootste deel rente en los je in verhouding minder af. Tegen het einde van de looptijd los je juist meer af en betaal je steeds minder hypotheekrente.'} />
                            </div>

                            <div className="ct-step__sidebar-checklines-block">
                                <CheckLine
                                    text={intl.formatMessage({id: 'stepSidebar.mortgageInfo.annuity.checkline1', defaultMessage: 'Gelijkblijvende bruto maandlasten.'})}

                                />

                                <CheckLine
                                    text={intl.formatMessage({id: 'stepSidebar.mortgageInfo.annuity.checkline2', defaultMessage: 'In vergelijking met een lineaire hypotheek, is bij aanvang het maandbedrag minder hoog.'})}
                                />

                                <CheckLine
                                    text={intl.formatMessage({id: 'stepSidebar.mortgageInfo.annuity.checkline3', defaultMessage: 'Zekerheid dat je de hypotheek helemaal aflost.'})}
                                />
                            </div>
                        </TabPanel>

                        <TabPanel>
                            <div className="ct-tab__title">
                              <FormattedMessage id={'stepSidebar.mortgageInfo.linear.payoff'} defaultMessage={'Steeds lagere maandlasten'} />
                            </div>

                            <div className="ct-tab__text">
                              <FormattedMessage id={`stepSidebar.mortgageInfo.linear.text`} defaultMessage={`Een lineaire hypotheek heeft lineaire (gelijke) aflossing. Iedere maand wordt dus hetzelfde bedrag afgelost. De bijbehorende rente is hiermee in het begin het hoogst en bouwt af gedurende de looptijd. Bij een lineaire hypotheek moet je dus rekening houden met een relatief hoog maandbedrag bij aanvang.`} />
                            </div>

                            <div className="ct-step__sidebar-checklines-block">
                                <CheckLine
                                    text={intl.formatMessage({id: 'stepSidebar.mortgageInfo.linear.checkline1', defaultMessage: 'Tijdens de looptijd los je elke maand hetzelfde bedrag af.'})}
                                />

                                <CheckLine
                                    text={intl.formatMessage({id: 'stepSidebar.mortgageInfo.linear.checkline2', defaultMessage: 'Hogere maandbedrag bij aanvang maar over de gehele looptijd betaal je minder rente.'})}
                                />

                                <CheckLine
                                    text={intl.formatMessage({id: 'stepSidebar.mortgageInfo.linear.checkline3', defaultMessage: 'Zekerheid dat je de hypotheek helemaal aflost.'})}
                                />
                            </div>
                        </TabPanel>
                    </Tabs>
                ) : (
                    <div>
                        <div className="ct-step__sidebar-subtitle">
                          <FormattedMessage id={'stepSidebar.period.payoff'} defaultMessage={'Rentevaste periode is de afgesproken periode dat de rente gelijk blijft.'} />
                        </div>

                        <div className="ct-step__sidebar-text">
                            <FormattedMessage id={'stepSidebar.period.text1'} defaultMessage={'Het rentepercentage voor jouw hypotheek kun je voor verschillende rentevaste perioden vastzetten. Je kan kiezen voor variabele of vaste rente. En als je kiest voor vaste rente, dan zijn de keuzes van 1 jaar tot en met 30 jaar, dit verschilt per geldverstrekker. In de meeste gevallen geldt: bij een langere rentevaste periode hoort ook een hoger rentepercentage.'} />
                            <br/><br/>
                            <FormattedMessage id={'stepSidebar.period.text2'} defaultMessage={'Aan de hand van een aantal vragen stelt de hypotheekadviseur vast wat de beste optie is voor jou. Houd je van zekerheid en wil je niet voor verrassingen komen te staan? Dan is het verstandiger om je hypotheekrente voor een langere periode vast te zetten. Verwacht je dat je in de toekomst meer kan verdienen en daarmee grotere stijgingen in de rente kunt veroorloven, dan kun je ervoor kiezen om de rente voor een kortere periode vast te zetten.'} />
                        </div>
                    </div>
                )}


            </div>

        </div>
    );
}

export default StepSidebar;
